var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestionCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#330072"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3446 6.90616C10.8327 6.81836 10.3063 6.91455 9.85852 7.1777C9.41076 7.44085 9.07059 7.85398 8.89824 8.34391C8.77229 8.70196 8.37993 8.89011 8.02188 8.76416C7.66383 8.6382 7.47568 8.24584 7.60163 7.88779C7.88169 7.09166 8.43448 6.42032 9.16209 5.9927C9.88969 5.56508 10.7452 5.40877 11.577 5.55145C12.4088 5.69412 13.1633 6.12659 13.7068 6.77224C14.2502 7.41779 14.5477 8.2348 14.5465 9.07861C14.5462 10.4053 13.5603 11.306 12.7973 11.8147C12.3948 12.083 11.9972 12.2813 11.7029 12.4121C11.5548 12.4779 11.4305 12.5277 11.3415 12.5616C11.297 12.5785 11.2611 12.5916 11.2355 12.6007L11.2047 12.6115L11.1953 12.6147L11.1922 12.6157L10.9728 11.9644L11.1901 12.6164C10.8301 12.7364 10.4409 12.5418 10.3208 12.1818C10.2009 11.822 10.395 11.4332 10.7545 11.3128L10.7575 11.3118L10.775 11.3056C10.7916 11.2997 10.8178 11.2902 10.8522 11.2771C10.9211 11.2509 11.0222 11.2105 11.1447 11.156C11.3917 11.0463 11.7157 10.8838 12.0348 10.671C12.7149 10.2176 13.172 9.67531 13.172 9.078C13.1728 8.55864 12.9897 8.05474 12.6553 7.65742C12.3208 7.26009 11.8565 6.99396 11.3446 6.90616Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3627 15.8128C10.3627 15.4332 10.6704 15.1255 11.0499 15.1255H11.0596C11.4391 15.1255 11.7468 15.4332 11.7468 15.8128C11.7468 16.1923 11.4391 16.5 11.0596 16.5H11.0499C10.6704 16.5 10.3627 16.1923 10.3627 15.8128Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionCard);
export default __webpack_public_path__ + "static/media/iconQuestionCard.d84bab24f770065cd9b75bd4e7713d51.svg";
export { ForwardRef as ReactComponent };